import {FontHandler} from "@k/js/fontHandler";

import {resourcemanagerVue} from "./resourceManagerVue";
import {LogoPoolStoreWrapper} from "@km/components/logo/logoPoolWrapper";
import {IOwayoDataModel} from "@k/js/model";
import {Controller, EntwurfTransferProvider, controllerFor3DViewer, CurrentOwayProductProvider} from "@k/js/controller";
import ErrorHandlerAlert from "@km/js/ErrorHandlerAlert";
import {OwayoJSKonfiViewer} from "@k/js/owayoJSViewerWithSelObs";
import {StocklogoController} from "@k/js/stocklogos/stocklogoController";
import {ActionController} from "@k/js/actionController";
import {ProductController} from "@k/js/produktController";
import globalsObject from "@k/js/globalsObject";
import {EntwurfStoreWrapperStore} from "@km/store/entwurfStoreWrapperStore";
import store from "@km/store";
import {StockLogoStoreWrapper} from "@km/js/StockLogoStoreWrapper";
import {FontStorageWrapper} from "@km/store/FontStore";
import {UserStoreWrapper} from "@km/js/UserStoreWrapper";
import {GetParametersDecoded, Vector2} from "@k/js/delme_globals";

import {Entwurf} from "@k/js/entwurfsObjekt";
import {SelectableObjectInsertionPointFinder} from "@k/global/SelObInsertionPointFinder";
import {ProductStageWrapperStore} from "@km/js/ProductStageWrapperStore";
import {ModelStoreWrapper} from "@km/store/modelStore";
import {AuswahlProduktStoreWrapper} from "@km/store/ProduktAuswahlStore";
import {UserManagementConnectorRoutes} from "@k/global/UserManagementConnectorRoutes";
import {PatternPreviewImageHolder} from "@km/store/ColorDataGetterFromResourceStore";
import {GoogleTracker} from "@k/global/googleTrackerObject";
import {startup} from "@k/js/startup/startup";
import {
    AdressenPersistance,
    AdressenPersistanceAxiosAjaxConnector,
} from "@k/global/AdressenPersistance";
import {LocalizerVue} from "@km/js/LocalizerVue";
import {CookieHandler} from "@k/global/cookieconsent/cookieHandler";
import {loginOnPageLoad} from "@km/js/loginOnPageLoad";
import {EventListener} from "@k/global/eventVerteiler";
import {LoopTracker, LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";

export let owayoModelWrapper:IOwayoDataModel;

export class InitMobile {

    private readonly lang : string;
    private readonly domain: string;
    private readonly land: string;
    private readonly isKundenKonfi : boolean;
    private readonly infoFromGetParameters : GetParametersDecoded;

    constructor(infoFromGetParameters:GetParametersDecoded) {
        this.infoFromGetParameters = infoFromGetParameters;
        this.lang = infoFromGetParameters.lang;
        this.domain = infoFromGetParameters.domain;
        this.land = infoFromGetParameters.land;
        this.isKundenKonfi= infoFromGetParameters.kundenKonfi !== "";
    }

    public getEmailFromActiveUser():string{
        return globalsObject.controller.model.user.getEmail() || "";
    }

    public run():void {
        new PatternPreviewImageHolder();
        globalsObject.googleTracker = new GoogleTracker(
            this.infoFromGetParameters.domain,
            this.infoFromGetParameters.sportFuerProduktauswahl.webInZielsprache,
            this.infoFromGetParameters.productInfo.product.webInZielsprache,
            this.infoFromGetParameters.kundenKonfi,
            this.infoFromGetParameters.land,
            this.getEmailFromActiveUser
        );

        globalsObject.loopTracker = new LoopTracker();

        globalsObject.infoFromGetParameters = this.infoFromGetParameters;
        globalsObject.googleTracker.trackPageview("3Dkonfiguratoroffen.htm");
        globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_OPEN);
        globalsObject.resourceManager = resourcemanagerVue;
        Entwurf.setDataInteractor(new EntwurfStoreWrapperStore(store))
        AdressenPersistance.setAjaxConnector(new AdressenPersistanceAxiosAjaxConnector());
        globalsObject.localizer = new LocalizerVue(this.lang, this.infoFromGetParameters.locale, this.infoFromGetParameters.land);
        globalsObject.usermanagementConnector = new UserManagementConnectorRoutes();
        UserManagementConnectorRoutes.initLanguage(this.lang)

        globalsObject.errorHandler = new ErrorHandlerAlert();
        new FontHandler(new FontStorageWrapper(store));
        // this.initLoginAdditinalFeatures();
        const model = new ModelStoreWrapper(store, new EntwurfStoreWrapperStore(store), LogoPoolStoreWrapper, new UserStoreWrapper(store));
        owayoModelWrapper = model;

        store.commit("ModelStore/initFromGetParameters",
        {
            lang: this.lang,
                land: this.land,
            domain: this.domain,
            infoFromGetParameters: this.infoFromGetParameters
        }
        )
        globalsObject.stockLogoStore = StockLogoStoreWrapper;
        globalsObject.controller = new Controller(model, new EntwurfTransferProvider(), this.infoFromGetParameters, globalsObject.googleTracker);
        Controller.setErrorHandler(globalsObject.errorHandler);
        Controller.setResourcemanager(globalsObject.resourceManager);
        if(import.meta.env.DEV) {
            store.commit("debugStore/SET_CONTROLLER", globalsObject.controller)
        }

        globalsObject.resourceManager.checkTasksAndExecute();
        // localizer = new Localizer(this.lang, infoFromGetParameters.locale, infoFromGetParameters.land);
        globalsObject.owayoJSViewer = new OwayoJSKonfiViewer(
            globalsObject.controller as controllerFor3DViewer,
            globalsObject.controller.selObController,
            document.getElementById('3DViewer') as HTMLElement,
            globalsObject.controller as CurrentOwayProductProvider
        );
        (window as any).owayoJSViewer = globalsObject.owayoJSViewer;
        globalsObject.selObInsertionFinder = new SelectableObjectInsertionPointFinder(
            ()=>globalsObject.owayoJSViewer.getPartAndUVUnderMouse(new Vector2(0,0)),
            ()=>globalsObject.owayoJSViewer.getDroppableParts().map(p=>p.name));
        globalsObject.actionController = new ActionController(globalsObject.controller.model, globalsObject.owayoJSViewer, globalsObject.owayoJSViewer, null, false);

        InitMobile.initProductController(model)
        startup(
            this.infoFromGetParameters,
            this.isKundenKonfi,
            (username, password)=>loginOnPageLoad(
                globalsObject.resourceManager,
                username,
                password,
                this.infoFromGetParameters.lang,
                this.infoFromGetParameters.land
            )
        );
        // this.loadInitialModel();
        new StocklogoController(StockLogoStoreWrapper, function() {return globalsObject.productController.isPatternErlaubt()}, this.infoFromGetParameters.lang);
        // store.dispatch("loadproduktKategorien", {sport:model.websport, kundenKonfi:model.kundenKonfi});
        store.dispatch("loadProduktAuswahldaten",  {
            sport: model.getWebsportFuerProduktAuswahlNormalized(),
            land: model.getLieferland(),
            language: model.getSprache(),
            kundenKonfi: model.getKundenKonfi()
        });
        store.dispatch("ModelStore/loadContactData");
        if(import.meta.env.DEV || CookieHandler.konfiDevelopementCookieSet()) {
            (window as unknown as any).globalsObject = globalsObject;
            (window as unknown as any).controller = globalsObject.controller;
        } else {
            window.onbeforeunload = function (e) {
                if(!store.getters.needsSaving) {
                    return;
                }
                e = e || window.event;

                // For IE and Firefox prior to version 4
                if (e) {
                    e.returnValue = 'Any string';
                }

                // For Safari
                return 'Any string';
            };
        }
        new EventListener().addEventListener("ProductChangedEvent", ()=>{
            globalsObject.resourceManager.createTask("makeEntwurfDirty").discardAfterExecution()
                .when("entwurfInitialized", "done")
                .thenDo(()=>store.commit("SET_ENTWURF_changedSinceSave")
                )
        });
    }

    private static initProductController(model:IOwayoDataModel) {
        globalsObject.productController = new ProductController(
            model,
            new ProductStageWrapperStore(store),
            new AuswahlProduktStoreWrapper(store),
            (sport)=>{
                store.commit("ModelStore/setWebsportFuerProduktAuswahlNormalized", sport);
                return new AuswahlProduktStoreWrapper(store)
            }
        );
        globalsObject.productController.produkte.loadProdukte();
    }

}
